import EDeliveryEvents from "./event/EDeliveryEvents";

var EDeliveryEditController = function ($scope, $rootScope, EDeliveryFactory, $modalInstance, eventBus) {
    var vm = this;

    vm.model = null;
    vm.isDataLoaded = false;
    vm.planName = '';
    vm.docTypes = '';

    $scope.submitted = false;
    vm.email = {};



    if (EDeliveryFactory.getEConsentemailAddress() !== null && EDeliveryFactory.getEConsentemailAddress() !== '') {
        vm.email.primary = EDeliveryFactory.getEConsentemailAddress();
    }

    if (EDeliveryFactory.getSecondaryEmail() !== null && EDeliveryFactory.getSecondaryEmail() !== '') {
        vm.email.secondary = EDeliveryFactory.getSecondaryEmail();
    }

    if (EDeliveryFactory.getPlanName() !== null && EDeliveryFactory.getPlanName() !== '') {
        vm.planName = EDeliveryFactory.getPlanName();
    }

    if (EDeliveryFactory.getDocTypes() !== null && EDeliveryFactory.getDocTypes() !== '') {
        vm.docTypes = EDeliveryFactory.getDocTypes();
    }


    vm.eConsent = {
        emailchoice: EDeliveryFactory.getEConsentemailAddress(),
        pptInd: EDeliveryFactory.getPptConsent(),
        gaId: EDeliveryFactory.getGaId()
    };

    $scope.updateParticipantConsent = function (flowName) {


        var inputs = [
            'emailchoice',
            'pptInd'
        ];

        inputs.forEach(function (input) {
            $scope.eConsentForm[input].$touched = true;

        });
        if ($scope.eConsentForm.$valid) {

            var updateEConsentParams = {
                "email": vm.eConsent.emailchoice,
                "consentInd": vm.eConsent.pptInd,
                "gaId": vm.eConsent.gaId,
                "flowName": flowName
            };

            eventBus.dispatch(EDeliveryEvents.E_CONSENT_SUBMIT, this, {
                values: updateEConsentParams
            });

            EDeliveryFactory.updateParticipantConsent.query(updateEConsentParams,
                function (data, headers) {
                    $modalInstance.dismiss('cancel');

                    var retrieveConsentData = {
                        "gaId": EDeliveryFactory.getGaId()
                    };

                    EDeliveryFactory.retrieveParticipantConsent.query(retrieveConsentData,
                        function (data, headers) {
                            if (data !== null) {
                                EDeliveryFactory.setAllowedToOverwrite(data.data.allowedToOverwrite);
                                EDeliveryFactory.setEDeliveryOption(data.data.eDeliveryOption);
                                EDeliveryFactory.setDocTypes(data.data.docTypes);
                                EDeliveryFactory.setPlanName(data.data.planName);
                                EDeliveryFactory.setEConsentemailAddress(data.data.econsentemailAddress);
                                EDeliveryFactory.setPptConsent(data.data.pptConsent);
                                EDeliveryFactory.setSecondaryEmail(data.data.secondaryEmailAddress);
                                $rootScope.$emit('eConsentUpdated', {});

                            }

                        }, function (response) {

                        });

                },

                function (response) {

                });

        } else {
            eventBus.disptach(EDeliveryEvents.E_CONSENT_SUBMIT_INVALID, this);
        }
    };


    /**
     *  Close modal window
     **/
    $scope.cancel = function () {
        eventBus.dispatch(EDeliveryEvents.CANCEL, this, {
            source: "e_consent_modal"
        });
        $modalInstance.dismiss('cancel');
    };

    $scope.eDeliveryCheckbox = function () {
        eventBus.dispatch(EDeliveryEvents.E_DELIVERY_CHECKBOX, this);
    };
    $scope.emailChoiceChange = function () {
        eventBus.dispatch(EDeliveryEvents.EMAIL_CHOICE, this);
    };
    $scope.agreeClick = function () {
        eventBus.dispatch(EDeliveryEvents.AGREE, this);
    };
};

EDeliveryEditController.$inject = ['$scope', '$rootScope', 'EDeliveryFactory', '$modalInstance', 'eventBus'];
export default EDeliveryEditController;
